export const toMB = (speed) => speed / 1000
export const toGB = (speed) => speed / 1000000
export const isMB = (speed) => speed < 1000000

export const mbToKB = (speed) => speed * 1000

export const formatSpeedToPerSecond = (speed) =>
  speed ? (isMB(speed) ? `${toMB(speed)} Mbps` : `${toGB(speed)} Gbps`) : '-'

export const formatSpeedToMbpsNumber = (speed) => (speed ? toMB(speed) : '-')

const formatSpeed = (speed) => (speed ? (isMB(speed) ? `${toMB(speed)}Mb` : `${toGB(speed)}Gb`) : '-')

export default formatSpeed
